import { root, id } from './encoder-profiles';
import * as idEndpoints from './id';
import { options } from './options';

export const encoderProfiles = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
  options,
};
